import evolveImageLoader, {
  EVOLVE_IMAGE_SRC_REGEX,
} from 'utils/imageLoaders/evolveImageLoader'

const getCloudinaryPlaceholder = (id) => {
  if (EVOLVE_IMAGE_SRC_REGEX.test(id)) {
    return evolveImageLoader({ src: id, width: 200, quality: 10 })
  }

  return `https://res.cloudinary.com/evolve-vacation-rental-network/image/upload/f_auto,c_limit,w_200,q_10,e_blur:1000/${id}`
}

export default getCloudinaryPlaceholder
